export const C_PAGINATIONDEFAULT = {
  MAX_VISIBLE_PAGES: 3
} as const;
